module.exports = __webpack_public_path__ + "img/user.b16d0d84.svg";